import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import { useOutletContext, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isEmpty, toLower } from "lodash";
import moment from "moment";

import {
  bodyRequest,
  distributorQuick,
  distributorRequest,
} from "../../helpers/utils";
import { endpoints } from "../../helpers/endpoints";

import TitlePage from "./components/TitlePage";
import SkeletonProducts from "./components/SkeletonProducts";
import Filter from "./components/Filter";
import Map from "../../components/Maps";
import Items from "./components/Items";
import HeaderTabs from "./components/HeaderTabs";
import Breadcrumb from "./components/Breadcrumb";

import okayama1 from "../../assets/images/okayama.jpeg";
import okayama2 from "../../assets/images/okayama2.jpeg";
import okayama3 from "../../assets/images/okayama3.jpeg";

import "react-loading-skeleton/dist/skeleton.css";
import "./style.scss";

const Products = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [changeLanguage, language] = useOutletContext();

  const options = [
    {
      value: "Rate-Ascending",
      label: t("rate_ascending"),
    },
    {
      value: "Rate-Descending",
      label: t("rate_descending"),
    },
    {
      value: "Name-Ascending",
      label: t("name_ascending"),
    },
    {
      value: "Name-Descending",
      label: t("name_descending"),
    },
  ];

  const [stateMap, setStateMap] = useState([]);
  const [services, setServices] = useState([]);
  const [servicesAll, setServicesAll] = useState([]);
  const [geocodes, setGeocodes] = useState(false);

  const [skeletonShow, setSkeletonShow] = useState("none");
  const [productsShow, setProductsShow] = useState("block");
  const [stateButton, setStateButton] = useState("quick");

  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState();
  const [pagination, setPagination] = useState(1);
  const [totalPagination, setTotalPagination] = useState(1);

  const [selectedOption, setSelectedOption] = useState("");

  const [category, setCategory] = useState();
  const [date, setDate] = useState("");
  const [priceRange, setPriceRange] = useState();
  const [keyword, setKeyword] = useState();
  const [selectedKeyword, setSelectedKeyword] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [token, setToken] = useState();

  const [breadcrumbName, setBreadcrumbName] = useState("体験");

  const productsRequest = bodyRequest;
  const langParams = searchParams.get("lang");
  productsRequest.request.Language = `${
    langParams === "en" ? "en-US" : "ja-JP"
  }`;

  const allCities = [
    "津山市",
    "真庭市",
    "美作市",
    "新庄村",
    "鏡野町",
    "勝央町",
    "奈義町",
    "西粟倉村",
    "久米南町",
    "美咲町",
    "美作エリア",
    "倉敷市",
    "笠岡市",
    "井原市",
    "総社市",
    "高梁市",
    "新見市",
    "浅口市",
    "早島町",
    "里庄町",
    "矢掛町",
    "備中エリア",
    "岡山市",
    "玉野市",
    "備前市",
    "瀬戸内市",
    "赤磐市",
    "和気町",
    "吉備中央町",
    "備前エリア",
  ];

  const allCitiesEn = [
    "Okayama City",
    "Tamano City",
    "Bizen City",
    "Setouchi City",
    "Akaiwa City",
    "Wake Town",
    "Kibichuo Town",
    "Bizen area",
    "Kurashiki City",
    "Kasaoka City",
    "Ibara City",
    "Soja City",
    "Takahashi City",
    "Niimi City",
    "Asakuchi City",
    "Hayashima Town",
    "Satosho Town",
    "Yakage City",
    "Bitchu area",
    "Tsuyama City",
    "Maniwa City",
    "Mimasaka City",
    "Shinjo Village",
    "Kagamino Town",
    "Katsuo Town",
    "Nagi Town",
    "Nishiawakura Village",
    "Kumeninami Town",
    "Misaki Town",
    "Mimasaka  area",
  ];

  useEffect(() => {
    setPage(1);
    setToken(null);
    productsRequest.request.Paging.PageNumber = 1;

    productsRequest.request.Availability = {
      MergeMethod: 1,
      Window: {
        Size: 42,
        StartDate: new Date(),
      },
    };
    productsRequest.request.Filter = {
      TagCritera: {},
      Type: "Service",
    };

    const catParams = searchParams.get("category");
    const min = searchParams.get("min");
    const max = searchParams.get("max");
    const keyword = searchParams.get("keyword");
    const date = searchParams.get("date");
    const sort = searchParams.get("sort");
    const city = searchParams.get("city");
    const type = searchParams.get("type");
    let filterValues = {};

    if (catParams) {
      productsRequest.request.Filter.TagCriteria = {
        IndustryCategoryGroups: [catParams],
      };
      setCategory(parseInt(catParams));
      sessionStorage.setItem("category", catParams);
    } else {
      productsRequest.request.Filter.TagCriteria = {
        IndustryCategoryGroups: [0, 1, 2],
      };
      setCategory(parseInt(catParams));
      sessionStorage.setItem("category", "all");
    }
    if (min || max) {
      productsRequest.request.Filter.Bookability.RateRange = {
        Min: min,
        Max: max,
      };
      setPriceRange(`${min}-${max}`);
    }
    if (date) {
      productsRequest.request.Availability.Window.StartDate = new Date(date);
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }
    if (keyword) {
      productsRequest.request.Filter.Names = [`%${keyword}%`];
      setKeyword(keyword);
    }

    if (selectedKeyword) {
      productsRequest.request.Filter.Names = [`%${selectedKeyword}%`];
    }

    if (sort) {
      setSelectedOption(sort);
      productsRequest.request.Sorting = [
        {
          By: `${sort.split("-")[0]}`,
          Direction: `${sort.split("-")[1]}`,
        },
      ];
    } else {
      productsRequest.request.Sorting = [
        {
          By: "Random",
        },
      ];
    }

    if (city) {
      let cities;
      if (typeof city === "string") {
        if (city?.includes(",")) {
          cities = city?.split(",");
        } else {
          cities = [city];
        }
      }

      setSelectedCity(cities);
    }

    delete productsRequest.request.Filter.Ids;
    searchParams.delete("pages");
    setSearchParams(searchParams);

    productsRequest.request.Language = `${
      langParams === "en" ? "en-US" : "ja-JP"
    }`;
    pageNames();
    getData({
      checkCity: city,
      type: type || "quick",
      filter: true,
      filterValues,
    });
  }, []);

  useCallback(() => {
    productsRequest.request.Language = `${
      langParams === "en" ? "en-US" : "ja-JP"
    }`;

    let filterValues = {};
    const date = searchParams.get("date");
    if (date) {
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }
    const catSession = sessionStorage.getItem("category");
    searchParams.set("category", category || catSession || "all");
    setSearchParams(searchParams);
    productsRequest.request.Filter.TagCriteria = {
      IndustryCategoryGroups: [category || catSession || 0, 1, 2],
    };
    if (langParams === language) {
      pageNames();
      getData({ filterValues, checkCity: selectedCity });
      window.scrollTo(0, 0);
    }
  }, [language]);

  useEffect(() => {
    stateMap &&
      stateMap.map((item) => {
        if (item.HasGeocodes) {
          setGeocodes(true);
        }
      });
  }, [stateMap]);

  const changeCategory = (cat) => {
    setCategory(cat);
    searchParams.set("category", cat);
    setSearchParams(searchParams);
    let filterValues = {};
    const date = searchParams.get("date");
    if (date) {
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }
    productsRequest.request.Filter.TagCriteria = {
      IndustryCategoryGroups: [cat],
    };
    getData({ filterValues });
  };

  const resetPage = () => {
    setPage(1);
    searchParams.delete("pages");
    setToken(null);
    setPagination(1);
  };

  // Dispatch data
  const fetchData = async (params) => {
    try {
      const requestType =
        params?.type === "request" ? distributorRequest : distributorQuick;
      const pageNumber = params.page || 1;

      productsRequest.request.ShortName = requestType;
      productsRequest.request.Paging.PageNumber = pageNumber;
      productsRequest.request.Paging.PageSize = 100;
      const response = await axios.post(endpoints.search, productsRequest);
      setServicesAll(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const filterByDate = (dataServices, date) => {
    return dataServices.map((el) => ({
      ...el,
      availableDate: el?.Children[0]?.Availability?.Calendar?.DailyRates?.some(
        (rate) =>
          rate?.Date === moment(date).format("YYYY-MM-DD") && rate?.IsAvailable
      ),
    }));
  };

  const filterByCity = (dataServices, cities) => {
    return dataServices.map((item) => {
      const itemCity = item?.PhysicalAddress?.City;

      // Initialize the availableCity flag to false
      item.availableCity = false;

      // Check if "Others" criteria is met
      if (
        (cities.includes("Others") || cities.includes("その他")) &&
        !item.availableCity
      ) {
        let isOther = true;
        const checkCities = language === "en" ? allCitiesEn : allCities;
        // Check against allCities to see if the item city matches any
        for (const city of checkCities) {
          if (toLower(itemCity) === toLower(city)) {
            isOther = false;
            break;
          }
        }

        // If the city is not in allCities, mark it as available
        if (isOther) {
          item.availableCity = true;
        }
      }

      // Check if the item city matches any of the specified cities
      for (const city of cities) {
        if (toLower(itemCity) === toLower(city)) {
          item.availableCity = true;
          break;
        }
      }

      return item;
    });
  };

  const dispatchData = async (params) => {
    try {
      let finalData = [];
      if (params?.pagination === 1) {
        const response = await fetchData(params);
        if (!response) return;

        let dataServices = response.Entities;
        if (params.page && params.page > 1) {
          dataServices = [...services, ...dataServices];
        }

        if (params.values?.date) {
          dataServices = filterByDate(dataServices, params.values.date);
        }

        if (!isEmpty(params.checkCity)) {
          let checkCity = params.checkCity;
          if (typeof checkCity === "string") {
            checkCity = checkCity.includes(",")
              ? checkCity.split(",")
              : [checkCity];
          }
          dataServices = filterByCity(dataServices, checkCity);
        }

        finalData = dataServices.filter((item) => {
          const hasDate = params.values?.date;
          const hasCity = !isEmpty(params.checkCity);

          return (
            (!hasDate || item.availableDate) && (!hasCity || item.availableCity)
          );
        });

        if (!params.page || params.page < 2) {
          setToken(response.Paging.Token);
        }

        if (
          finalData.length === 0 &&
          response.Paging.NumberOfPages > params.page
        ) {
          loadMore(params.page);
        }

        setPageCount(dataServices?.length);
        const sort = searchParams.get("sort");
        if (sort && (sort === "Rate-Ascending" || sort === "Rate-Descending")) {
          finalData.sort((a, b) => {
            const rateA = a.Availability?.Calendar?.LowestRate || 0;
            const rateB = b.Availability?.Calendar?.LowestRate || 0;
            return sort === "Rate-Ascending" ? rateA - rateB : rateB - rateA;
          });
        } else if (
          sort &&
          (sort === "Name-Ascending" || sort === "Name-Descending")
        ) {
          finalData.sort((a, b) => {
            const nameA = a.Name;
            const nameB = b.Name;
            return sort === "Name-Ascending" ? nameA - nameB : nameB - nameA;
          });
        }
        setTotalPagination(Math.ceil(finalData.length / 10));

        finalData = finalData.slice(
          10 * (params?.pagination - 1),
          10 * params?.pagination
        );
      }

      if (params?.pagination > 1) {
        finalData = servicesAll?.Entities.slice(
          10 * (params?.pagination - 1),
          10 * params?.pagination
        );
        finalData = [...services, ...finalData];
      }
      setPagination(params?.pagination + 1);
      setServices(finalData);
      setProductsShow("block");
      setSkeletonShow("none");
    } catch (error) {
      console.error("Error handling data:", error);
    }
  };

  const updateStateMap = (data) => {
    setStateMap((ss) => [...ss, ...data]);
  };
  const dispatchMap = (type) => {
    productsRequest.request.Paging = {};
    productsRequest.request.ShortName =
      type === "request" ? distributorRequest : distributorQuick;

    axios.post(endpoints.search, productsRequest).then((response) => {
      updateStateMap(response.data.Entities);
    });
  };

  const getData = (payload) => {
    if (!payload?.loadMore) {
      window.scrollTo(0, 0);
    }
    setSkeletonShow("block");
    if (payload?.page && payload?.page > 1) {
      productsRequest.request.Paging.PageNumber = payload?.page;
      searchParams.get("page", page);
      productsRequest.request.Paging.Token = token;
      delete productsRequest.request.Filter;
      delete productsRequest.request.Campaign;
      delete productsRequest.request.Availability;

      dispatchData({
        page: payload?.page,
        checkCity: payload?.checkCity,
        type: payload?.type,
        values: payload?.filterValues,
        sort: payload?.sort,
        pagination: payload?.pagination,
      });
    } else {
      setProductsShow("none");
      productsRequest.request.Paging.PageNumber = 1;

      dispatchData({
        checkCity: payload?.checkCity,
        type: payload?.type,
        values: payload?.filterValues,
        page: payload?.page || 1,
        pagination: payload?.pagination || 1,
      });
    }

    dispatchMap("quick");
    // dispatchMap("request");
  };

  // Filter
  const filterData = (values) => {
    resetPage();
    productsRequest.request.Filter = {
      Type: "Service",
      TagCriteria: {},
    };
    if (values.minRange) {
      if (values.minRange === "0") {
        productsRequest.request.Filter.Bookability.RateRange = {};
        searchParams.delete("min");
        searchParams.delete("max");
      } else {
        productsRequest.request.Filter.Bookability.RateRange = {
          Min: values.minRange,
          Max: values.maxRange,
        };
        searchParams.set("min", values.minRange);
        searchParams.set("max", values.maxRange);
      }
    }
    if (values.date) {
      if (moment(values.date).format("LL") !== moment().format("LL")) {
        searchParams.set(
          "date",
          moment(new Date(values.date)).format("YYYY-MM-DD")
        );
      } else {
        searchParams.delete("date");
      }
    } else {
      searchParams.delete("date");
    }
    if (values.category) {
      if (!values.category || values.category === "all") {
        productsRequest.request.Filter.TagCriteria = {
          IndustryCategoryGroups: [0, 1, 2],
        };
        searchParams.delete("category");
      } else {
        productsRequest.request.Filter.TagCriteria = {
          IndustryCategoryGroups: [values.category],
        };
        searchParams.set("category", values.category);
      }
    } else {
      const catSession = sessionStorage.getItem("category");
      const catParams = searchParams.get("category");
      const allCat = [0, 1, 2];
      const totalCat = catSession === "all" ? allCat : [catSession];
      const industryCategoryGroups =
        (catParams && [parseInt(catParams)]) || totalCat;

      productsRequest.request.Filter.TagCriteria = {
        IndustryCategoryGroups: industryCategoryGroups,
      };
    }
    const dataKeyword = selectedKeyword?.map((item) => `%${item}%`);

    if (values.keyword) {
      dataKeyword.push(`%${values.keyword}%`);
      productsRequest.request.Filter.Names = dataKeyword;
      searchParams.set("keyword", values.keyword);
    } else {
      if (!isEmpty(values.selectedKeyword)) {
        delete productsRequest.request.Filter.Names;
      }
      searchParams.delete("keyword");
    }

    if (!isEmpty(values.selectedKeyword)) {
      productsRequest.request.Filter.Names = dataKeyword;
      searchParams.set("selectedKeyword", values.selectedKeyword);
    } else {
      if (!values.keyword) {
        delete productsRequest.request.Filter.Names;
      }
      searchParams.delete("selectedKeyword");
    }

    if (!isEmpty(values.city)) {
      searchParams.set("city", values.city);
    } else {
      searchParams.delete("city");
    }

    if (page > 1) {
      setPage(1);
    }

    setSearchParams(searchParams);
    pageNames();

    let filterValues = {};
    const date = searchParams.get("date");
    if (date) {
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }

    getData({ checkCity: values.city, filterValues });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  const changeToQuick = () => {
    let filterValues = {};
    const date = searchParams.get("date");
    if (date) {
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }
    getData({ page: 1, type: "quick", filterValues });
    setStateButton("quick");
    searchParams.set("type", "quick");
  };

  const changeToMap = () => {
    setStateButton("map");
  };

  // Sort
  const onSort = (value) => {
    resetPage();
    setSelectedOption(value);
    productsRequest.request.Sorting = [
      {
        By: `${value.split("-")[0]}`,
        Direction: `${value.split("-")[1]}`,
        PositionOfNull: "AlwaysOnBottom",
      },
    ];
    searchParams.set("sort", value);
    setSearchParams(searchParams);
    let filterValues = {};
    const date = searchParams.get("date");
    if (date) {
      setDate(new Date(date));
      filterValues = {
        date: new Date(date),
      };
    }

    getData({ filterValues, type: stateButton, sort: value });
  };

  // Load more data
  const loadMore = (currentPage) => {
    let paging = page + 1;
    if (currentPage) {
      paging = currentPage + 1;
    }
    searchParams.set("pages", paging);
    searchParams.delete("pages_request");
    setSearchParams(searchParams);

    setPage(paging);
    getData({
      page: paging,
      type: stateButton,
      loadMore: true,
      checkCity: selectedCity,
    });
  };

  const loadMorePagination = () => {
    let paging = page + 1;
    getData({
      page: paging,
      pagination,
      type: stateButton,
      loadMore: true,
      checkCity: selectedCity,
    });
  };

  const pageNames = () => {
    let breadcrumb = "";
    switch (category) {
      case "1":
        breadcrumb = t("activity");
        break;
      case "2":
        breadcrumb = t("restaurant");
        break;
      default:
        breadcrumb = t("search");
        break;
    }

    setBreadcrumbName(breadcrumb);
  };

  return (
    <div className="products">
      <div className="productsWrapper" style={{ display: productsShow }}>
        <Breadcrumb category={category} breadcrumbName={breadcrumbName} />
        <TitlePage category={category} />
        <HeaderTabs category={category} changeCategory={changeCategory} />
        <Filter
          lang={langParams || language}
          filter={filterData}
          date={date}
          category={category}
          priceRange={priceRange}
          keyword={keyword}
          setKeyword={setKeyword}
          setDate={setDate}
          setCategory={setCategory}
          setPriceRange={setPriceRange}
          selectedKeyword={selectedKeyword}
          setSelectedKeyword={setSelectedKeyword}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
        />

        <div className="container categoryTabs">
          <nav>
            <div
              type="button"
              className="cursor-pointer"
              onClick={() => changeCategory(1)}
            >
              <div
                className={`categoryTabs__item ${
                  category == "1" ? "active" : ""
                }`}
              >
                {t("activity")}
              </div>
            </div>
            <div
              type="button"
              className="cursor-pointer"
              onClick={() => changeCategory(2)}
            >
              <div
                className={`categoryTabs__item ${
                  category == "2" ? "active" : ""
                }`}
              >
                {t("restaurant")}
              </div>
            </div>
          </nav>
        </div>
        <div className="productsOption">
          <div className="container">
            <div className="searchCount">
              <span>{pageCount}</span>
              <span className="count">{t("ken")}</span> {t("items")}
            </div>
            <div className="optionWrapper">
              <div className="d-flex sort">
                {options.map((o, i) => (
                  <Button
                    variant={selectedOption === o.value ? "primary" : "white"}
                    key={i}
                    onClick={() => onSort(o.value)}
                  >
                    {o.label}
                  </Button>
                ))}
              </div>
              <div className="d-flex">
                <div className="me-2">
                  <Form.Select
                    onChange={(e) => changeLanguage(e)}
                    value={langParams ? langParams : language}
                  >
                    <option value="jp">日本語 (Japanese)</option>
                    <option value="en">英語 (English)</option>
                  </Form.Select>
                </div>
                <div className="Products__buttonType">
                  <Button
                    variant={stateButton === "quick" ? "primary" : "white"}
                    onClick={() => changeToQuick()}
                  >
                    {t("quick_booking")}
                  </Button>
                  {/* <Button
                    variant={stateButton === "request" ? "primary" : "white"}
                    onClick={() => changeToRequest()}
                  >
                    {t("request_book")}
                  </Button> */}
                  <Button
                    variant={stateButton === "map" ? "primary" : "white"}
                    onClick={() => changeToMap()}
                  >
                    {t("map")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div
            className="productItems"
            style={{ display: stateButton !== "map" ? "block" : "none" }}
          >
            <Items
              services={services}
              loadMorePagination={loadMorePagination}
              totalPagination={totalPagination}
              pagination={pagination}
              state={stateButton}
              category={category}
            />
          </div>
          <div
            className="productsMap"
            style={{ display: stateButton === "map" ? "block" : "none" }}
          >
            {geocodes && stateMap.length > 0 && (
              <Map positions={stateMap} zoom={9} />
            )}
          </div>
        </div>
      </div>

      <div className="container">
        <div className="skeletonWrapper" style={{ display: skeletonShow }}>
          <SkeletonProducts currentPage={page} category={category} />
        </div>
      </div>

      {category && category == 1 ? (
        <div className="sliders">
          <div className="container">
            <div className="item">
              <a
                href="https://www.asoview.com/brand/taiken-okayama/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={okayama1} alt="" />
              </a>
            </div>
            <div className="item">
              <a
                href="https://okayama.visit-town.com"
                target="_blank"
                rel="noreferrer"
              >
                <img src={okayama2} alt="" />
              </a>
            </div>
            <div className="item">
              <a
                rel="noreferrer"
                target="_blank"
                href="https://app.tabi-wester.westjr.co.jp/ticketList?prefecture_id=3&utm_source=okayamakankoweb&utm_medium=referral&utm_campaign=202207_okayamakankoweb&region_id=10"
              >
                <img src={okayama3} alt="" />
              </a>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Products;
